import React, { useContext, useEffect, useState, useRef } from "react";
import MediaQuery from "react-responsive";
import { RouteComponentProps } from "react-router-dom";
import { isTablet, isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import forEach from "lodash/forEach";
import Spinner from "react-bootstrap/Spinner";
// import { Element } from 'react-scroll'; // use only if changing AssetList to scroll view
import GoogleMap from "./components/GoogleMap";
import AssetList from "./components/AssetList";
import Container from "react-bootstrap/Container";
import AssetListHeader from "./components/AssetListHeader";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {
  CustomAsset,
  CustomAssetVariant,
  CustomAssetChild,
  CustomAssetGroup,
  LocationBounds,
} from "../../../../interface/Client";
import { AssetType, AssetArea } from "../../../../enum";
import { reducer } from "../../../../context";
import { AssetListContainer } from "./AssetListScreenStyles";
import agent from "../../../../agent";
import actionType from "../../../../context/actionType";
// import { MOCK_ASSETS } from '../../../../mockData';
// import MathHelper from '../../../../helpers/MathHelper';
// import MockDataHelper from '../../../../helpers/MockDataHelper';
import { Asset, GeneralProject } from "../../../../interface/Server";
import { logResponse } from "../../../../helpers/Logger";

import Api from "../../../../helpers/Api";

let pageThreshold = 2;
const DEFAULT_PRICE_RANGE = [0, 50000];
const TABS = ["List", "Map"];

interface Props extends RouteComponentProps {}

const AssetListScreen: React.FunctionComponent<Props> = (props) => {
  const { assetsReducer, googleMapReducer, formReducer, configReducer } =
    useContext(reducer);
  const assetStatus = assetsReducer.state.showDonors
    ? {}
    : { assetStatus: "OnShelf" };
  const { t } = useTranslation();
  const [fixed, setFixed] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [currentTab, setCurrentTab] = useState(TABS[0]);
  const [generalProjects, setGeneralProjects] = useState<Array<GeneralProject>>(
    [
      {
        createDate: "",
        description: "",
        fundCode: "",
        image: "",
        images: [],
        projectCode: "",
        projectId: 0,
        projectName: "",
        projectNameZH: "",
        status: "",
        updateDate: "",
      },
    ]
  );
  const [loading, setLoading] = useState(true);
  const [loadingNextPage, setLoadingNextPage] = useState(false);
  const [initialLoad, setInitialLoading] = useState(true);
  // const prevMapBounds = useRef<LocationBounds>();
  const { filter } = assetsReducer.state;
  const { mapBounds } = googleMapReducer.state;
  const toggleLoadingOverlay = (showLoading: boolean) => {
    configReducer.dispatch({
      type: actionType.config.TOGGLE_LOADING,
      payload: {
        showLoading,
      },
    });
  };
  // detect when at end of list to increase page number
  // only update page number if stopped loading and API call is successful
  const scrollToEndDetect = (isLoading: boolean) => {
    const windowHeight =
      "innerHeight" in window
        ? window.innerHeight
        : document.documentElement.offsetHeight;
    const body = document.body;
    const html = document.documentElement;
    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    const windowBottom = windowHeight + window.pageYOffset;
    if (!isLoading && windowBottom >= docHeight && !loadingNextPage) {
      setLoadingNextPage(true);
      setPageNumber((prev: number) => {
        if (pageThreshold === prev) return prev;
        return prev + 1;
      });
    }
  };
  // add on scroll listener to update map position and call scrollToEndDetect
  // set [loading] into second argument to ensure updated value is passed to scrollToEndDetect
  useEffect(() => {
    window.addEventListener("scroll", () => {
      scrollToEndDetect(loading);
      if (!isTablet && window.scrollY > 145) {
        return setFixed(true);
      }
      if (isTablet && window.scrollY > 200) {
        return setFixed(true);
      }
      setFixed(false);
    });
    formReducer.dispatch({
      type: actionType.form.SET_SCREEN,
      payload: {
        screen: "assetList",
      },
    });
    // returned function will be called on component unmount
    return () => {
      window.removeEventListener("scroll", () => {});
    };
  }, [loading]);

  const onSelectAsset = (asset: Asset) => {
    formReducer.dispatch({
      type: actionType.form.START_FORM_STAGE,
      payload: {
        selectedAsset: asset,
      },
    });
    const auth = sessionStorage.getItem("auth");
    const headers = {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: "" + auth,
    };
    fetch(`${Api.path(window.location)}/asset/${asset.assetId}`, {
      method: "GET",
      headers: headers,
    })
      .then(function (response) {
        return response.json();
      })
      .then((resJson) => {
        logResponse(configReducer.state.debugMode, `asset: ${resJson.msg}`);
        if (resJson.msg == "OK") {
          sessionStorage.setItem(
            "SELECTED_ASSET",
            JSON.stringify(resJson.data)
          );
          sessionStorage.removeItem("SELECTED_PROJECT");
          if (props.history && props.history.push) {
            props.history.push(
              "auth/user/nameplate" + `?asset=${asset.assetId}`
            );
          }
        }
      });
  };
  const onSelectProject = (project: GeneralProject) => {
    formReducer.dispatch({
      type: actionType.form.START_FORM_STAGE,
      payload: {
        selectedProject: project,
      },
    });
    const auth = sessionStorage.getItem("auth");
    const headers = {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: "" + auth,
    };
    fetch(`${Api.path(window.location)}generalProject/${project.projectId}`, {
      method: "GET",
      headers,
    })
      .then(function (response) {
        return response.json();
      })
      .then((resJson) => {
        console.info("Project Json");
        console.info(resJson);

        logResponse(
          configReducer.state.debugMode,
          `generalProject: ${resJson.msg}`
        );
        if (resJson.msg == "OK") {
          sessionStorage.setItem(
            "SELECTED_PROJECT",
            JSON.stringify(resJson.data)
          );
          sessionStorage.removeItem("SELECTED_ASSET");
          if (props.history && props.history.push) {
            props.history.push(
              "auth/user/nameplate" + `?generalProject=${project.projectId}`
            );
          }
        }
      });
  };

  const setGroupedAssetsToState = (res: any, appendList: boolean = false) => {
    const groupedAssetResponse =
      (res.data && res.data.groups && res.data.groups.englishName) || res;
    const groupedAssetList: Asset[] = []; // for list view
    const assetList: Asset[] = []; // for map

    groupedAssetResponse.forEach((assetGroup: any) => {
      if (assetGroup && assetGroup.groupName && assetGroup.dataList.length) {
        groupedAssetList.push({
          ...assetGroup.dataList[0],
          childrenAssets: assetGroup.dataList,
        });
        assetList.concat(assetGroup.dataList);
      }
    });
    assetsReducer.dispatch({
      type: actionType.assets.ASSETS_INIT_ASSETS,
      payload: {
        assets: groupedAssetList, // JOSHUA TODO append next page to groupedAssetList and googleMapReducer assetList markers
        // assetGroups, // auto group as queryGroup API not available
      },
    });
    googleMapReducer.dispatch({
      type: actionType.googleMap.GOOGLE_MAP_INIT_MARKER,
      payload: {
        markers: assetList,
      },
    });
    if (!appendList) {
      setSortedAssets(groupedAssetList);
    } else {
      setSortedAssets(sortedAssets.concat(groupedAssetList));
    }
    setLoading(false);
    toggleLoadingOverlay(false);
  };

  // do not filter Sponsored assets in this list, because they still need to be displayed on map
  const setAssetsToState = (res: any, appendList: boolean = false) => {
    console.log("assets response", res);
    if (res && res.data && res.data.groups) {
      setGroupedAssetsToState(res, appendList);
      return;
    }
    const assetList = (res.data && res.data.dataList) || res;
    /* Mock data step (not used in production) */
    // if(!assetList) {
    //     return setSortedAssets(MOCK_ASSETS);
    // }
    (assetList || []).forEach((asset: Asset) => {
      if (asset.location && asset.location.lat && asset.location.lon) {
        asset.position = {
          lat: Number(asset.location.lat),
          lng: Number(asset.location.lon),
        };
      } else if (asset.latitude && asset.longitude) {
        asset.position = {
          lat: Number(asset.latitude),
          lng: Number(asset.longitude),
        };
      }
      /* Mock data step (not used in production) */
      // add randomly generated coordinates if API does not provide
      // asset.position = MathHelper.generateCoordinates();
    });

    /* Mock data step (not used in production) */
    // randomly generate images for display until endpoint has images
    // assetList.forEach((asset: Asset) => asset.image = !!asset.image ? asset.image : MockDataHelper.generateImagePath(asset.englishName));

    /* Remove assets that will NOT be grouped - 20190830 confirm that ALL assets will be grouped by English Name*/
    // filter out seat and bench assets from full list (they will be added later on as grouped assets)
    const groupedAssetList: Asset[] = []; //assetList.filter((asset: Asset) => asset.englishName !== 'Bench' && asset.project !== 'Pick a Seat');

    // map all assets into arrays and to corresponding technical names (to set certain assets as children assets for grouping)
    const assetGroups = agent.assets.mapResponseToObject(assetList);
    const assetGroupKeys = Object.keys(assetGroups);
    // console.warn('assetGroupKeys', assetGroupKeys)
    assetGroupKeys.forEach((key) => {
      // if((key.indexOf('BenchType:') > -1 || key.indexOf('SeatType:') > -1) && (assetGroups[key] && assetGroups[key].length)) {
      if (assetGroups[key] && assetGroups[key].length) {
        groupedAssetList.push({
          ...assetGroups[key][0],
          childrenAssets: assetGroups[key],
        });
      }
    });
    assetsReducer.dispatch({
      type: actionType.assets.ASSETS_INIT_ASSETS,
      payload: {
        assets: groupedAssetList, // JOSHUA TODO append next page to groupedAssetList and googleMapReducer assetList markers
        assetGroups, // auto group as queryGroup API not available
      },
    });
    googleMapReducer.dispatch({
      type: actionType.googleMap.GOOGLE_MAP_INIT_MARKER,
      payload: {
        markers: assetList,
      },
    });

    if (!appendList) {
      setSortedAssets(groupedAssetList);
    } else {
      setSortedAssets(sortedAssets.concat(groupedAssetList));
    }
    setLoading(false);
    toggleLoadingOverlay(false);
  };

  const filterAssets = (assets: Array<any>): Array<any> => {
    console.log("success", assets);
    if (!filter) return assets;
    if (filter.area) {
      assets = assets.filter((n) => {
        const isAreaMatch = filter.area === n.area;
        return isAreaMatch;
      });
    }
    if (filter.code) {
      let temp = assets.find(
        (asset) =>
          asset.assets &&
          asset.assets.filter(
            (variant: { code: string | undefined }) =>
              variant.code === filter.code
          ).length > 0
      );
      if (!temp) return [];
      let sortedVariants = temp.assets.find(
        (n: { code: string | undefined }) => n.code === filter.code
      ) as CustomAssetVariant;
      temp.assets = [sortedVariants];
      return [temp];
    }
    if (filter.price) {
      let filterPrice: {
        min: number;
        max: number;
      } = filter.price;
      assets = assets.map((asset) => {
        let sortedVariants = asset.assets.filter(
          (variant: { price: number }) => {
            let isPriceRangeOverlap =
              variant.price <= filterPrice.max &&
              filterPrice.min <= variant.price;
            return isPriceRangeOverlap;
          }
        );
        return {
          ...asset,
          variants: sortedVariants,
        };
      });
    }

    assets = assets.filter((asset) => {
      let hasVariantsToShow = asset.assets.length > 0;
      return hasVariantsToShow;
    });
    return assets;
  };
  const [sortedAssets, setSortedAssets] = useState(() => filterAssets([]));
  useEffect(() => {
    setSortedAssets(() => filterAssets([]));
  }, [filter]);
  const initAssetsList = async () =>
    await agent.assets.queryAssetsWithParameters({
      ...assetStatus,
      pageSize: 50,
      pageNumber: 1,
      giftAmountMin: DEFAULT_PRICE_RANGE[0],
      giftAmountMax: DEFAULT_PRICE_RANGE[1],
      groupBy: ["englishName"],
    });
  const getGeneralProject = async () =>
    await agent.assets.queryGeneralProject();
  // query more assets for next page and append to asset list
  // will not attempt to query first page or while already loading new assets
  useEffect(() => {
    // TODO load / set pages param to set max page number to scroll to;
    if (!initialLoad && !loading && pageNumber > 1) {
      agent.assets
        .queryAssetsWithParameters({
          groupBy: ["englishName"],
          ...assetStatus,
          pageSize: 50,
          pageNumber,
          ...(!!filter
            ? {
                giftAmountMin:
                  (filter.price && filter.price.min) || DEFAULT_PRICE_RANGE[0],
                giftAmountMax:
                  (filter.price && filter.price.max) || DEFAULT_PRICE_RANGE[1],
                zone: filter.area,
                type: filter.type,
              }
            : {}),
        })
        .then((res) => {
          const { data } = res;
          if (data) {
            setAssetsToState(res, true);
          }
          setLoadingNextPage(false);
          pageThreshold++;
        });
    }
  }, [pageNumber]);
  useEffect(() => {
    if (initialLoad) {
      return;
    }
    console.log("filter CHANGE!", assetsReducer.state.filter);
    const filter = assetsReducer.state.filter;
    setPageNumber(1);
    pageThreshold = 2;
    if (filter) {
      setLoading(true);
      toggleLoadingOverlay(true);
      agent.assets
        .queryAssetsWithParameters({
          groupBy: ["englishName"],
          ...assetStatus,
          pageSize: 50,
          pageNumber: 1,
          giftAmountMin:
            (filter.price && filter.price.min) || DEFAULT_PRICE_RANGE[0],
          giftAmountMax:
            (filter.price && filter.price.max) || DEFAULT_PRICE_RANGE[1],
          zone: filter.area,
          type: filter.type,
        })
        .then((res) => {
          // update URL based on filter options // TODO need to update values to avoid using Chinese chars and upper case letters
          const params = new URLSearchParams();
          if (filter) {
            filter.area &&
              params.append(
                "area",
                filter.area === "林地" ? "land" : "seaside"
              );
            filter.type && params.append("type", filter.type.toLowerCase());
            if (filter.price) {
              filter.price.min !== undefined &&
                params.append("min", filter.price.min.toString());
              filter.price.max !== undefined &&
                params.append("max", filter.price.max.toString());
            }
          }
          props.history.push({
            search: params.toString(),
          });
          if (res && res.data) {
            setAssetsToState(res);
          }
          setLoading(false);
          toggleLoadingOverlay(false);
        });
    }
  }, [assetsReducer.state.filter, assetsReducer.state.showDonors]);
  // query assets based on current map bounds using geoBoxQuery API
  // overwrites previous asset list
  useEffect(() => {
    // 2019-09-18 remove checking since it does not auto zoom triggering a search on load
    // if(prevMapBounds.current === undefined && !!mapBounds) {
    //     prevMapBounds.current = mapBounds; // use ref of prev map bounds to prevent query on initial mapBound setState
    //     return;
    // }
    if (mapBounds && !initialLoad && !loading) {
      // prevMapBounds.current = mapBounds;
      toggleLoadingOverlay(true);
      const showDonorParam = assetsReducer.state.showDonors
        ? {}
        : { status: "OnShelf" };
      const priceFilterParams =
        filter && filter.price
          ? {
              giftAmountInterval: {
                max:
                  (filter.price && filter.price.max) || DEFAULT_PRICE_RANGE[1],
                min:
                  (filter.price && filter.price.min) || DEFAULT_PRICE_RANGE[0],
              },
            }
          : {};
      const assetTypeParams = filter
        ? {
            zone: filter.area,
            type: filter.type,
          }
        : {};
      agent.assets
        .queryGeoBoxWithParameters({
          location: mapBounds,
          pageNumber: 1,
          pageSize: 10,
          ...showDonorParam,
          ...priceFilterParams,
          ...assetTypeParams,
        })
        .then((res) => setAssetsToState(res));
    }
  }, [mapBounds]);
  useEffect(() => {
    setInitialLoading(true);
    toggleLoadingOverlay(true);
    getGeneralProject().then((res) => {
      setGeneralProjects(res || []);
    });
    initAssetsList().then((res) => {
      setInitialLoading(false);
      // update filter based on URL search params // TODO optimise loading process and useEffect usage
      if (document.location && document.location.search) {
        var searchParams = new URLSearchParams(document.location.search);
        const filter = { price: {} } as { [key: string]: any }; // Object.assign({}, assetsReducer.state.filter);
        const params = ["min", "max", "area", "type"];
        forEach(params, (param: string) => {
          if (!searchParams.has(param)) {
            return;
          }
          if (param === "min" || param === "max") {
            filter.price[param] = Number(searchParams.get(param));
          } else if (param === "type") {
            const value = searchParams.get(param);
            filter[param] =
              value && value.charAt(0).toUpperCase() + value.slice(1);
          } else if (param === "area") {
            const value =
              searchParams.get(param) === "seaside" ? "海濱" : "林地";
            filter[param] = value;
          }
        });
        assetsReducer.dispatch({
          type: actionType.assets.ASSET_EDIT_FILTER,
          payload: {
            filter,
          },
        });
      }
      setAssetsToState(res);
    });
  }, []);
  const renderMap = ({
    isMobile = false,
    isTablet = false,
  }: {
    isMobile?: boolean;
    isTablet?: false;
  }) => {
    const mapElementStyle = isTablet
      ? { minHeight: window.innerHeight - 50 }
      : isMobile
      ? { height: "475px" }
      : { minHeight: `475px` };
    const sizes = isMobile
      ? {}
      : {
          xs: 12,
          sm: 12,
          md: 12,
          lg: 12,
          xl: 12,
        };
    return (
      <GoogleMap
        onSelectAsset={onSelectAsset}
        isMarkerShown
        googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyDrmv1sZDViMVf8iXPkGOPQ2ZsWlzAEUeo&libraries=geometry,drawing,places"
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={
          <Col
            {...sizes}
            style={
              isMobile
                ? {}
                : {
                    right: -6,
                    top: 180,
                    bottom: "auto",
                    position: "sticky", // maybe need to be dynamic until scrolled down far enough
                    padding: 0,
                  }
            }
          />
        }
        // mapElement={<div style={{minHeight: `475px`, maxHeight: `750px`, minWidth: '475px'}}/>}
        mapElement={
          <div style={{ width: "100%", display: `flex`, ...mapElementStyle }} />
        }
      />
    );
  };
  // TODO add event listener for window resize to dyanmic adjust scroll view
  // see: https://stackoverflow.com/questions/36862334/
  console.log("sorted assets", sortedAssets);
  return (
    <>
      <AssetListHeader isMobile={isMobile} />
      {isMobile ? (
        <>
          <div
            style={{
              flexDirection: "row",
              flex: 1,
              display: "flex",
              margin: 16,
              padding: 0,
            }}
          >
            {TABS.map((tab) => (
              <div
                style={{
                  borderWidth: 1,
                  borderStyle: "solid",
                  flex: 1,
                  alignContent: "center",
                  padding: 8,
                  display: "flex",
                  justifyContent: "center",
                  ...(currentTab === tab
                    ? {
                        backgroundColor: "#FFF",
                        color: "#2c3c4e",
                        borderColor: "#2c3c4e",
                        fontWeight: "bold",
                      }
                    : {
                        backgroundColor: "#2c3c4e",
                        color: "#FFF",
                        borderColor: "#2c3c4e",
                      }),
                }}
                onClick={() => setCurrentTab(tab)}
              >
                {t(tab)}
              </div>
            ))}
          </div>
          {currentTab === TABS[1] && renderMap({ isMobile: true })}
          {currentTab === TABS[0] && (
            <Col style={{ marginTop: "20px" }}>
              <AssetList
                isMobile={isMobile}
                generalProjectList={generalProjects}
                assets={sortedAssets}
                onSelectAsset={onSelectAsset}
                onSelectProject={onSelectProject}
                loading={initialLoad}
              />
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {loadingNextPage ? (
                  <Spinner
                    style={{ width: 32, height: 32 }}
                    animation="border"
                    size="sm"
                    variant="secondary"
                  />
                ) : (
                  <div style={{ width: 32, height: 32 }} />
                )}
              </div>
            </Col>
          )}
        </>
      ) : (
        <AssetListContainer id="assetList">
          <Container style={{ maxWidth: "100%" }}>
            <Row style={{ paddingLeft: 20 }}>
              <Col
                style={{ marginTop: "20px" }}
                xs={8}
                sm={8}
                md={8}
                lg={8}
                xl={8}
              >
                <AssetList
                  generalProjectList={generalProjects}
                  assets={sortedAssets}
                  onSelectAsset={onSelectAsset}
                  onSelectProject={onSelectProject}
                  loading={initialLoad}
                />
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  {loadingNextPage ? (
                    <Spinner
                      style={{ width: 32, height: 32 }}
                      animation="border"
                      size="sm"
                      variant="secondary"
                    />
                  ) : (
                    <div style={{ width: 32, height: 32 }} />
                  )}
                </div>
              </Col>
              {!isMobile && <Col>{renderMap({})}</Col>}
            </Row>
          </Container>
        </AssetListContainer>
      )}
    </>
  );
};

export default AssetListScreen;
